export const LESSON_STATUS_OPTIONS = [
  { label: 'Не отчитались', value: '0' },
  { label: 'Проведено', value: '5' },
  { label: 'Перенесено', value: '9' },
  { label: 'Отмена учеником', value: '10' },
  { label: 'Отмена педагогом', value: '11' },
  { label: 'Платная отмена', value: '12' },
]

export const REPORTABLE_LESSON_STATUS_OPTIONS = LESSON_STATUS_OPTIONS.filter(
  ({ value }) => value !== '0',
)

export const LESSON_FILTER_STATUS_OPTIONS = [
  ...LESSON_STATUS_OPTIONS,
  { label: 'Не оплачено', value: '14' },
]

export const canSubmitLessonStatuses = (
  rows: Array<{ status?: unknown; joined_after_lesson?: boolean }>,
): boolean => rows.length > 0 && rows.every(
  (row) => row.joined_after_lesson || [5, 9, 10, 11, 12].includes(Number(row.status)),
)

export function getStatusDescription(value: string) {
  switch (value) {
    case '5':
      return 'Проведено'
    case '9':
      return 'Перенесено'
    case '10':
      return 'Отмена учеником'
    case '11':
      return 'Отмена педагогом'
    case '12':
      return 'Платная отмена'
    case '14':
      return 'Не оплачено'
    default:
      return 'Не отчитались'
  }
}

export function getCompactStatusSymbol(value: string) {
  switch (value) {
    case '5':
      return '✓'
    case '9':
      return '↔'
    case '10':
      return 'У'
    case '11':
      return 'П'
    case '12':
      return '$'
    case '14':
      return '!'
    default:
      return '—'
  }
}

export function getStatusColor(value: string) {
  switch (value) {
    case '5':
      return 'var(--color-status-success-border)'
    case '9':
      return 'var(--color-status-warning)'
    case '10':
      return 'var(--color-status-danger-border)'
    case '11':
    case '14':
      return 'var(--color-status-danger-border)'
    case '12':
      return 'var(--color-status-danger-bg)'
    default:
      return 'var(--color-status-warning-border)'
  }
}
